import { ChangeEvent, useEffect, useState } from 'react';
import { UIData, useUIStore } from '../../hooks/stores/uiStore';
import { useScene } from '../../context/sceneContext';

export const EditingTextarea = () => {
  const scene = useScene();
  const [UIData] = useUIStore<UIData>();
  const [originalValue, setOriginalValue] = useState('');

  const data = scene.getSelectedElementsData({ text: undefined }, 'props');
  const computedStyle = UIData.elementInEditingModeID
    ? scene.getElementComputedStyle(UIData.elementInEditingModeID) || {}
    : {};

  useEffect(() => {
    data.text && setOriginalValue(data.text);
  }, []);

  return (
    <textarea
      defaultValue={data.text}
      autoFocus={true}
      spellCheck={false}
      onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
        scene.updateSelectedElementsData(
          { text: e.currentTarget.value },
          'props'
        );
      }}
      onKeyDown={(e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter') {
          scene.endEditingElement(e.currentTarget?.value);
        }
        if (e.key === 'Escape') {
          scene.endEditingElement(originalValue);
        }
      }}
      style={{
        all: 'unset',
        ...computedStyle,
        position: 'fixed',
        left: UIData.elementHandle.pos.x,
        top: UIData.elementHandle.pos.y,
        width: UIData.elementHandle.width,
        height: UIData.elementHandle.height,
        zIndex: 1,
        outline: '2px solid var(--primary-1)',
        borderRadius: 'var(--radius-1)',
        overflow: 'hidden',
        opacity: 1,
        animation: 'none',
        transition: 'none',
        minHeight: '1em',
        minWidth: '1em',
      }}
    />
  );
};
